export default __webpack_public_path__ + "static/media/ic-msg.1af74964.svg";